import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Observable, shareReplay } from 'rxjs';


export interface RegressionRate {
    id: string;
    metricIdId: string;
    rateIdStatistical: string;
    rateName: string;
    category: string;
    displayType: string;
    displayOrder: number;
    information?: string;
}

export interface RegressionDropdown {
    categoryTitle: string;
    metricId: string;
    metricTitle: string;
    displayOrder: number;
    displayType: string;
    rates: RegressionRate[];

}

@Injectable({
    providedIn: 'root'
})
export class DropDownService {
    private apiService = inject(ApiService);
    private cache: Observable<RegressionDropdown[]> | null = null;


    public getRegressionDropdown(): Observable<RegressionDropdown[]> {
        if (!this.cache) {
            this.cache = this.apiService.get<RegressionDropdown[]>('/api/dropdown/regression')
                .pipe(shareReplay(1));
        }
        return this.cache;
    }

}
